<app-header-n (scroll)="onWindowScroll($event);"></app-header-n>
<div class="container">
    <div id="myModal8" class="modal">
        <span class="close2" (click)="closeModal()">&times;</span>
        <video class="modVideo" [src]="video" type="video/mp4" controls>
            Your browser does not support HTML video.
        </video>
        <div id="caption"></div>
    </div>
    <div class="modal-welcome">
        <div class="modal-welcome__content">
            <div class="modal-welcome__content__title">
                <h1>¡Felicidades!</h1>
            </div>
            <div class="modal-welcome__content__text">
                <p>Descubre un mundo lleno de posibilidades para hacer crecer tu negocio como nunca antes!</p>
                <p>¡Te garantizamos que nunca has visto nada igual!</p>
                <br>
                <p>Escucha atentamente lo que nuestro Co-fundador, Andrés Hernández, tiene para ti.</p>
                <h2>¡Bienvenido a Triidy!!</h2>
            </div>
            <div class="modal-welcome__content__video">
                <iframe title="vimeo-player"
                    src="https://player.vimeo.com/video/796410735?h=d619ac2206?portrait=false&title=false"
                    frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="modal-welcome__content__button">
                <a class="btn" href="https://www.triidypluss.com/Iniciaretotriidy">Ver el video exclusivo ahora</a>
            </div>
        </div>
    </div>
    <!-- <div>
        <div class="pasosTitle">
            <h2>¡Empezar en Triidy es muy fácil!</h2>
        </div>
        <div class="alert alert-success">
            <strong class="default"><i class="far fa-check-circle"></i> ¡Registro exitoso!</strong>
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
        </div>
        <div class="pasosT">
            <div class="pasos">
                <span class="number">1</span>
                <p>Descarga Triidy para Windows e inicia sesión</p>
                <button class="btn"
                (click)="clickModal('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/DescargarTriidy.mp4')"><i
                class="fas fa-tv"></i>&nbsp;&nbsp;Video</button>
            </div>
            <div class="pasos">
                <span class="number">2</span>
                <p>Crea tu producto o agrega uno de nuestros proveedores Dropshipping</p>
                <button class="btn"
                (click)="clickModal('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/CreaoAgregaProductos.mp4')"><i
                class="fas fa-tv"></i>&nbsp;&nbsp;Video</button>
            </div>
            <div class="pasos">
                <span class="number">3</span>
                <p>Solicita dinero en el booster y empieza a facturar tus ventas</p>
                <button class="btn"
                (click)="clickModal('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/RecargaoSolitudDineroBoost.mp4')"><i
                class="fas fa-tv"></i>&nbsp;&nbsp;Video</button>
            </div>
        </div>
        <div class="pasosTitle">
            <button class="btn" (click)="descarga()"><i class="fas fa-download"></i>&nbsp;&nbsp;Descarga para
                Windows</button>
            </div>
        </div>
    </div> -->
    <!-- <div class="alert alert-info">
        <strong class="default"><i class="far fa-check-circle"></i> Su clave por defecto: 123</strong>
        <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
    </div> -->
</div>
<app-footer-n></app-footer-n>